import { FormSchema, Lookups } from '@precert/validation';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Row, Col, FormGroup } from 'reactstrap';

import FormAddress from '../../../../_components/address';
import InputField from '../../../../_components/input-field';
import SelectField from '../../../../_components/select-components/select-field';
import type { WizardStepProps } from '../wizard';

import { valuesCodeArray } from './common';
const { SpecialTaxonomy, ProviderType } = Lookups;
const specialTaxonomyOptions = valuesCodeArray(SpecialTaxonomy);
const providerTypeOptions = valuesCodeArray(ProviderType);

export const StepRenderingProviderSchema = FormSchema().pick([
  'providerNpi',
  'providerName',
  'providerType',
  'facilityNpi',
  'facilityName',
  'infusionCode',
  'facilityAddress',
  'providerEmail',
  'serviceRender',
  'secondaryAddress',
]);

export interface StepRenderingProviderFormData {
  providerNpi: string;
  providerName: string;
  providerType?: string;
  specialTaxonomy?: string;
  facilityNpi: string;
  facilityName: string;
  facilityAddress: {
    street: string;
    street2?: string;
    city: string;
    state: string;
    zip: string;
  };
  providerEmail?: string;
  serviceRender: boolean;
  secondaryAddress?: {
    street: string;
    street2?: string;
    city: string;
    state: string;
    zip: string;
  };
}

export function StepRenderingProvider() {
  const { clearErrors, watch, resetField, setValue } = useFormContext();
  const renderingServices = watch('serviceRender');

  // TODO CCRA-37242
  useEffect(() => {
    if (renderingServices) {
      clearErrors('secondaryAddress');
      resetField('secondaryAddress');
    }
  }, [renderingServices]);
  return (
    <div className="pt-0">
      <h2>Provider Details</h2>
      <Row className="justify-content-center">
        <Col lg={6}>
          <FormGroup>
            <InputField
              required
              label="Provider NPI"
              id="providerNpi"
              name="providerNpi"
              aria-label="Provider NPI"
              type="text"
              maxLength={10}
            />
          </FormGroup>
        </Col>

        <Col lg={6}>
          <FormGroup>
            <InputField
              required
              label="Provider Name"
              id="providerName"
              name="providerName"
              aria-label="Provider Name"
              type="text"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col lg={6}>
          <FormGroup>
            <SelectField
              options={providerTypeOptions}
              label="Provider Type"
              name="providerType"
              onChange={(val) => {
                clearErrors('providerType');
                setValue('providerTypeCode', val.code);
              }}
            />
          </FormGroup>
        </Col>
        <Col lg={6}>
          <FormGroup>
            <SelectField
              label="Specialty-Taxonomy"
              options={specialTaxonomyOptions}
              name="specialTaxonomy"
              aria-label="Specialty-Taxonomy"
              onChange={(val) => {
                setValue('specialTaxonomyCode', val.code);
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <hr aria-hidden="true" />
      <h2>Facility Details</h2>
      <Row>
        <Col lg={6}>
          <FormGroup>
            <InputField
              required
              label="Facility NPI"
              id="facilityNpi"
              name="facilityNpi"
              aria-label="Facility NPI"
              type="text"
              maxLength={10}
            />
          </FormGroup>
        </Col>
        <Col lg={6}>
          <FormGroup>
            <InputField
              required
              label="Facility Name"
              id="facilityName"
              aria-label="Facility Name"
              name="facilityName"
              type="text"
            />
          </FormGroup>
        </Col>
      </Row>
      <FormAddress
        id="facility-address"
        fieldName="facilityAddress"
        secondaryAddress
        required
      />
      <Row>
        <Col sm={12} md={6}>
          <FormGroup>
            <SelectField
              required
              options={[
                {
                  label: 'Yes',
                  value: true,
                },
                {
                  label: 'No',
                  value: false,
                },
              ]}
              label="Are services being rendered at the providers address?"
              name="serviceRender"
            />
          </FormGroup>
        </Col>
      </Row>
      {!renderingServices && (
        <>
          <hr aria-hidden="true" />
          <FormAddress
            id="secondary-address"
            title="Secondary Address"
            fieldName="secondaryAddress"
            required
            secondaryAddress
          />
        </>
      )}
    </div>
  );
}

export const stepRenderingProvider: WizardStepProps = {
  title: 'Rendering Provider',
  schema: StepRenderingProviderSchema,
  element: <StepRenderingProvider />,
  path: 'rendering-provider',
};
